SC.profile_history = (function () {
  var api = {};
  var goToShopPurchaseBanner = {
    is_small: false,
    small_limit: 10,
    image: '<img role="presentation" src="/assets/images/profile/shopping-bag.svg" />',
    image_blue: '<a href="//shop.soul-cycle.com/us/en/order-tracking" class="go-shop-purchases-text-button" ><img role="presentation" src="/assets/images/profile/shopping-bag-black.svg" /></a>'
  };
  var init = function () {
    setEvents();

    // We should trigger infinite scrolling immediately to change loading message if its on the screen.
    triggerInfiniteScrolling();
  };

  var hireGotoShopText = function () {
    var element = document.getElementById('go-shop-purchases-text-container');
    if (element) {
      element.style.display = 'none';
    }
  };

  var showGotoShopText = debounce(function () {
    var element = document.getElementById('go-shop-purchases-text-container');
    if (element) {
      element.style.display = 'block';
    }
  }, 300);

  var goToShopPurchaseBannerToSmall = function () {
    hireGotoShopText();
    var element = document.getElementById('go-shop-purchases-container');
    var imageContainer = document.getElementById('go-shop-purchases-image-container');
    if (imageContainer) {
      imageContainer.innerHTML = goToShopPurchaseBanner.image_blue;
    }
    if (element) {
      element.classList.add('go-shop-purchases-small');
      element.classList.remove('go-shop-purchases');
    }
  };

  var goToShopPurchaseBannerToBig = function () {
    showGotoShopText();
    var element = document.getElementById('go-shop-purchases-container');
    var imageContainer = document.getElementById('go-shop-purchases-image-container');
    if (imageContainer) {
      imageContainer.innerHTML = goToShopPurchaseBanner.image;
    }
    if (element) {
      element.classList.add('go-shop-purchases');
      element.classList.remove('go-shop-purchases-small');
    }
  };


  var setEvents = function () {
    // enable infinite ajax scrolling
    window.addEventListener('scroll', triggerInfiniteScrolling);
    window.addEventListener('scroll', function () {
      var scrollPosition = window.scrollY;
      if (scrollPosition > goToShopPurchaseBanner.small_limit && !goToShopPurchaseBanner.is_small) {
        goToShopPurchaseBannerToSmall();
        goToShopPurchaseBanner.is_small = true;
      } else if (scrollPosition < goToShopPurchaseBanner.small_limit && goToShopPurchaseBanner.is_small) {
        goToShopPurchaseBannerToBig();
        goToShopPurchaseBanner.is_small = false;
      }
    });
  };


  /**
   * debounced trigger for infinite scrolling via ajax / lazy load
   */
  var triggerInfiniteScrolling = debounce(function () {
    var pager = document.getElementById('magic-invisible-scrolly-box');

    if (pager && checkVisible(pager)) {
      getNextPage();
    }
  }, 300);

  /**
    * returns true if given el is within the viewport
    *
    * @param {Object} el the dom element to check
    * @returns {boolean} true if el is within view
    */
  function checkVisible(el) {
    var rect = el.getBoundingClientRect();
    return window.innerHeight - rect.y > 0;
  }

  /**
   * load by ajax the next page based on the state of the window.soulcycle.profile.page variable
   * ... and then insert the page under the previous one
   * @returns {void}
   */
  function getNextPage() {
    // track which page we need to load
    ++window.soulcycle.profile.page;

    // everything hinges on the visibility of the pager
    var pager = document.getElementById('magic-invisible-scrolly-box');
    var tab = document.getElementsByClassName('profile-tabs__tab--active')[0];
    var link = tab.getAttribute('data-tab');
    var sub = tab.getAttribute('data-sub');

    // ajax load the next page
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/profile/' + link + '/page/' + window.soulcycle.profile.page + '/');
    xhr.send(null);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        // done
        var chl = document.getElementById(sub + '-history-list');
        var parent = document.getElementById(sub + '-tabpanel');

        if (xhr.status === 200) {
          // attach the new data to the old
          if (xhr.responseText === '') {
            $('#magic-invisible-scrolly-box').html('All purchases loaded');
          }
          pager.remove();
          chl.innerHTML = chl.innerHTML + xhr.responseText;
          parent.appendChild(pager);
        } else if (xhr.status === 404) { // no more classes
          pager.remove();

          // Create a new element to show they are at the end of their class history if its not on the page.
          if (!document.getElementById('end-history-message')) {
            var msg = document.createElement('div');

            msg.innerHTML = 'There are no more ' + sub +  ' to show!';
            msg.classList.add('profile-loading-message');
            msg.id = 'end-history-message';
            parent.appendChild(msg);
          }
        } else { // don't append garbage, but put pager back
          pager.remove();
          parent.appendChild(pager);
        }
      }
    };
  }

  /**
   * generic debounce function stolen from underscore.js
   *
   * @param {function} func the function to be run with debounce
   * @param {number} wait int the debounce timeout in ms
   * @param {boolean} immediate run function now instead of waiting
   * @returns {Function} the debounced version of func
   */
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(context, args);
      }
    };
  }

  init();

  return api;
})();
